/* ================================================================
   NayRosa theme — global.js  (vanilla, modular, no dependencies)
   ================================================================ */
(function () {
  'use strict';
  var NR = window.NayRosa || {};
  var routes = NR.routes || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function money(cents) {
    var fmt = NR.moneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, value)
             .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }
  window.nrMoney = money;

  /* ---------- Toast ---------- */
  var toast = $('#ToastAdd');
  var toastTimer;
  function showToast(msg) {
    if (!toast) return;
    if (msg) { var span = toast.querySelector('span'); if (span) span.textContent = msg; }
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('show'); }, 2200);
  }

  /* ---------- Header shadow ---------- */
  var header = $('.header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  /* ---------- Announcement rotation ---------- */
  $$('.announce .rot').forEach(function (rot) {
    var spans = $$('span', rot);
    if (spans.length < 2) return;
    var speed = parseInt(rot.getAttribute('data-speed'), 10) || 4200;
    var i = 0;
    setInterval(function () {
      spans[i].classList.remove('on');
      i = (i + 1) % spans.length;
      spans[i].classList.add('on');
    }, speed);
  });

  /* ---------- Drawers (open via [data-drawer-open="ID"]) ---------- */
  function openDrawer(el) {
    if (!el) return;
    el.classList.add('open');
    var ov = el.previousElementSibling;
    if (ov && ov.classList.contains('drawer-overlay')) ov.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer(el) {
    if (!el) return;
    el.classList.remove('open');
    var ov = el.previousElementSibling;
    if (ov && ov.classList.contains('drawer-overlay')) ov.classList.remove('open');
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer($('#' + opener.getAttribute('data-drawer-open'))); return; }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); var d = e.target.closest('.drawer'); closeDrawer(d); return; }
    if (e.target.classList.contains('drawer-overlay')) { closeDrawer(e.target.nextElementSibling); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') $$('.drawer.open').forEach(closeDrawer);
  });

  /* ---------- Accordions (FAQ + PDP) ---------- */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('.faq-q, .acc-q');
    if (!q) return;
    var item = q.parentElement;
    var panel = item.querySelector('.faq-a, .acc-a');
    var isOpen = item.classList.contains('open');
    if (q.classList.contains('faq-q')) {
      // single-open per FAQ group
      $$('.faq-item', item.closest('.faq') || document).forEach(function (it) {
        it.classList.remove('open');
        var p = it.querySelector('.faq-a'); if (p) p.style.maxHeight = null;
      });
    }
    if (!isOpen) { item.classList.add('open'); if (panel) panel.style.maxHeight = panel.scrollHeight + 'px'; }
    else { item.classList.remove('open'); if (panel) panel.style.maxHeight = null; }
  });
  // initialise any pre-opened panels
  $$('.faq-item.open .faq-a, .acc-item.open .acc-a').forEach(function (p) { p.style.maxHeight = p.scrollHeight + 'px'; });
  // FAQ category filter (visual only unless data-cat used)
  document.addEventListener('click', function (e) {
    var c = e.target.closest('.faq-cat'); if (!c) return;
    $$('.faq-cat', c.parentElement).forEach(function (x) { x.classList.remove('active'); });
    c.classList.add('active');
    var cat = c.getAttribute('data-cat');
    var list = c.closest('.faq').querySelector('[data-faq-list]');
    if (cat && list) {
      $$('.faq-item', list).forEach(function (it) {
        it.hidden = !(cat === 'all' || it.getAttribute('data-cat') === cat);
      });
    }
  });

  /* ---------- Cart: fetch + render drawer ---------- */
  var cartCountEls = function () { return $$('.cart-count'); };
  function setCartCount(n) { cartCountEls().forEach(function (el) { el.textContent = n; el.hidden = n === 0; }); }

  function renderCartDrawer(cart) {
    var body = $('#CartDrawer .cd-items');
    var footTotal = $('#CartDrawer [data-cart-total]');
    var bar = $('#CartDrawer [data-ship-fill]');
    var barMsg = $('#CartDrawer [data-ship-msg]');
    if (!body) return;
    setCartCount(cart.item_count);
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="empty-state"><div class="ei">' + iconCart() + '</div><p class="muted">Your bag is empty.</p><a href="/collections/all" class="btn btn-primary" data-drawer-close>Shop all</a></div>';
    } else {
      body.innerHTML = cart.items.map(function (it) {
        return '<div class="cd-item" data-key="' + it.key + '">' +
          '<img src="' + (it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, '_120x$1$2') : '') + '" alt="' + it.product_title + '" loading="lazy">' +
          '<div><div style="font-weight:600;font-size:14px">' + it.product_title + '</div>' +
          '<div class="muted" style="font-size:12px">' + (it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '') + '</div>' +
          '<div class="citem-actions" style="margin-top:6px"><div class="qty"><button data-qty="-1" aria-label="Decrease">–</button><span>' + it.quantity + '</span><button data-qty="1" aria-label="Increase">+</button></div>' +
          '<button class="remove" data-remove>Remove</button></div></div>' +
          '<div style="font-weight:700;font-size:14px">' + money(it.final_line_price) + '</div></div>';
      }).join('');
    }
    if (footTotal) footTotal.textContent = money(cart.total_price);
    var threshold = parseInt(document.documentElement.getAttribute('data-free-ship') || '0', 10) * 100;
    if (bar && threshold > 0) {
      var pct = Math.min(100, Math.round(cart.total_price / threshold * 100));
      bar.style.width = pct + '%';
      if (barMsg) barMsg.innerHTML = cart.total_price >= threshold
        ? '🎉 <b>You\'ve unlocked FREE shipping!</b>'
        : 'You\'re <b>' + money(threshold - cart.total_price) + '</b> away from free shipping';
    }
  }

  function refreshCart(open) {
    return fetch(routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCartDrawer(cart); if (open) openDrawer($('#CartDrawer')); return cart; });
  }

  function addToCart(id, qty, sellingPlan) {
    var payload = { items: [{ id: id, quantity: qty || 1 }] };
    if (sellingPlan) payload.items[0].selling_plan = sellingPlan;
    return fetch(routes.cart_add_url + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }

  function changeLine(key, qty) {
    return fetch(routes.cart_change_url + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  /* Add-to-cart forms (AJAX) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-cart-form]');
    if (!form) return;
    // Never intercept Shopify's dynamic checkout ("Buy it now") — let it submit natively
    if (e.submitter && (e.submitter.closest('.shopify-payment-button') || e.submitter.name === 'checkout')) return;
    e.preventDefault();
    var btn = form.querySelector('[data-add-btn]') || form.querySelector('button[type="submit"]:not([name="checkout"])');
    var idField = form.querySelector('[name="id"]');
    if (!idField || !idField.value) return;
    var qtyField = form.querySelector('[name="quantity"]');
    var planSelect = form.querySelector('[data-plan-select]');
    var sellingPlan = (planSelect && !planSelect.disabled && planSelect.value) ? planSelect.value : null;
    var qty = qtyField ? parseInt(qtyField.value, 10) || 1 : 1;
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.dataset.label = btn.innerHTML; btn.innerHTML = 'Adding…'; }
    addToCart(idField.value, qty, sellingPlan)
      .then(function () { return refreshCart(true); })
      .then(function () { showToast(); })
      .catch(function (err) { showToast((err && err.description) || 'Could not add to cart'); })
      .finally(function () { if (btn) { btn.removeAttribute('aria-disabled'); btn.innerHTML = btn.dataset.label; } });
  });

  /* Quick add buttons (data-add-id) */
  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-add-id]');
    if (!qa) return;
    e.preventDefault();
    qa.setAttribute('aria-disabled', 'true');
    addToCart(qa.getAttribute('data-add-id'), 1)
      .then(function () { return refreshCart(true); })
      .then(function () { showToast(); })
      .catch(function () { showToast('Could not add to cart'); })
      .finally(function () { qa.removeAttribute('aria-disabled'); });
  });

  /* Cart drawer qty +/- and remove */
  document.addEventListener('click', function (e) {
    var row = e.target.closest('.cd-item, .citem');
    if (!row) return;
    var key = row.getAttribute('data-key');
    if (!key) return;
    if (e.target.closest('[data-remove]')) { e.preventDefault(); changeLine(key, 0).then(function (c) { renderCartDrawer(c); if (window.nrReloadCartPage) window.nrReloadCartPage(c); }); return; }
    var q = e.target.closest('[data-qty]');
    if (q) {
      e.preventDefault();
      var span = row.querySelector('.qty span');
      var cur = span ? parseInt(span.textContent, 10) : 1;
      var next = Math.max(0, cur + parseInt(q.getAttribute('data-qty'), 10));
      changeLine(key, next).then(function (c) { renderCartDrawer(c); if (window.nrReloadCartPage) window.nrReloadCartPage(c); });
    }
  });

  // initial count sync
  if ($('#CartDrawer')) refreshCart(false);

  /* ---------- PDP: variant selection ---------- */
  $$('[data-product-form]').forEach(function (root) {
    var dataEl = $('[data-product-json]', root);
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var form = $('form[data-cart-form]', root);
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var priceNow = $('[data-price-now]', root);
    var priceWas = $('[data-price-was]', root);
    var priceOff = $('[data-price-off]', root);
    var addBtn = $('[data-add-btn]', root);
    var stickyPrice = $('[data-sticky-price]');
    var stickyBtn = $('[data-sticky-add]');

    function currentOptions() {
      return $$('[data-opt]', root).filter(function (i) { return i.checked; }).map(function (i) { return i.value; });
    }
    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function update() {
      var opts = currentOptions();
      var v = opts.length ? findVariant(opts) : product.variants.find(function (x) { return x.available; }) || product.variants[0];
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceNow) priceNow.textContent = money(v.price);
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      if (priceWas) { if (v.compare_at_price > v.price) { priceWas.textContent = money(v.compare_at_price); priceWas.hidden = false; } else priceWas.hidden = true; }
      if (priceOff && v.compare_at_price > v.price) { priceOff.textContent = 'Save ' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; priceOff.hidden = false; }
      else if (priceOff) priceOff.hidden = true;
      [addBtn, stickyBtn].forEach(function (b) {
        if (!b) return;
        if (v.available) { b.removeAttribute('aria-disabled'); b.dataset.text && (b.textContent = b.dataset.text); }
        else { b.setAttribute('aria-disabled', 'true'); b.textContent = NR.strings.soldOut; }
      });
      // update url
      if (history.replaceState && v.id) {
        var u = new URL(window.location);
        u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u);
      }
    }
    $$('[data-opt]', root).forEach(function (i) { i.addEventListener('change', update); });
    update();

    // qty steppers
    $$('.qty', root).forEach(function (qtyEl) {
      var input = qtyEl.querySelector('input');
      $$('button', qtyEl).forEach(function (b) {
        b.addEventListener('click', function () {
          var d = b.getAttribute('data-step') === '-1' ? -1 : (b.textContent.trim() === '–' ? -1 : 1);
          if (input) input.value = Math.max(1, (parseInt(input.value, 10) || 1) + d);
        });
      });
    });

    // purchase mode (one-time vs subscribe)
    var planRadio = root.querySelector('[data-plan-radio]');
    var planSelect = root.querySelector('[data-plan-select]');
    $$('.pm-opt', root).forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        if (e.target.closest('select')) return;
        $$('.pm-opt', root).forEach(function (x) { x.classList.remove('active'); });
        opt.classList.add('active');
        var sub = opt.getAttribute('data-mode') === 'sub';
        if (planRadio) planRadio.checked = !sub;      // empty-value radio = one-time
        if (planSelect) planSelect.disabled = !sub;   // disabled select is not submitted
      });
    });

    // sticky bar -> submit main form
    if (stickyBtn && form) stickyBtn.addEventListener('click', function () { if (stickyBtn.getAttribute('aria-disabled') === 'true') return; form.requestSubmit ? form.requestSubmit() : form.querySelector('[type=submit]').click(); });
  });

  /* ---------- PDP gallery ---------- */
  $$('[data-gallery]').forEach(function (g) {
    var main = $('[data-gallery-main]', g);
    $$('[data-thumb]', g).forEach(function (t) {
      t.addEventListener('click', function () {
        $$('[data-thumb]', g).forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
        if (main) { main.innerHTML = t.getAttribute('data-media-html') || ('<img src="' + t.getAttribute('data-full') + '" alt="">'); }
      });
    });
  });

  /* ---------- Collection filters + sort (auto-submit, no-JS friendly) ---------- */
  function submitFilterForm(form) {
    // Build URL preserving current path; include only checked/filled inputs
    var params = new URLSearchParams();
    $$('input, select', form).forEach(function (el) {
      if (el.type === 'checkbox' && !el.checked) return;
      if (!el.name || el.value === '') return;
      params.append(el.name, el.value);
    });
    var sort = $('[data-sort]');
    if (sort && sort.value) params.set('sort_by', sort.value);
    window.location.search = params.toString();
  }
  $$('[data-filter-form]').forEach(function (form) {
    form.addEventListener('change', function () { submitFilterForm(form); });
    form.addEventListener('submit', function (e) { e.preventDefault(); submitFilterForm(form); });
  });
  $$('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var u = new URL(window.location);
      u.searchParams.set('sort_by', sel.value);
      window.location.href = u.toString();
    });
  });

  /* ---------- Predictive search (basic) ---------- */
  var searchInputs = $$('[data-predictive-search]');
  searchInputs.forEach(function (input) {
    var results = document.getElementById(input.getAttribute('data-results')) || null;
    if (!results || !routes.predictive_search_url) return;
    var t;
    input.addEventListener('input', function () {
      clearTimeout(t);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      t = setTimeout(function () {
        fetch(routes.predictive_search_url + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5&section_id=predictive-search', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.text(); })
          .then(function (html) { results.innerHTML = html; })
          .catch(function () {});
      }, 250);
    });
  });

  /* ---------- Frequently bought together ---------- */
  $$('[data-fbt]').forEach(function (fbt) {
    var totalEl = $('[data-fbt-total]', fbt);
    function recalc() {
      var cents = 0;
      $$('[data-fbt-item]', fbt).forEach(function (i) { if (i.checked) cents += parseInt(i.getAttribute('data-price'), 10) || 0; });
      if (totalEl) totalEl.textContent = money(cents);
    }
    $$('[data-fbt-item]', fbt).forEach(function (i) { i.addEventListener('change', recalc); });
    recalc();
    var addBtn = $('[data-fbt-add]', fbt);
    if (addBtn) addBtn.addEventListener('click', function () {
      var items = $$('[data-fbt-item]', fbt).filter(function (i) { return i.checked; })
        .map(function (i) { return { id: parseInt(i.getAttribute('data-variant'), 10), quantity: 1 }; });
      if (!items.length) return;
      addBtn.setAttribute('aria-disabled', 'true');
      fetch(routes.cart_add_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json(); })
        .then(function () { return refreshCart(true); })
        .then(function () { showToast(); })
        .catch(function () { showToast('Could not add to cart'); })
        .finally(function () { addBtn.removeAttribute('aria-disabled'); });
    });
  });

  /* ---------- icons ---------- */
  function iconCart() { return '<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M6 7h12l-1 13H7L6 7z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg>'; }

  /* expose */
  window.nrRefreshCart = refreshCart;
  window.nrShowToast = showToast;
})();
